export type ProgressProps = {
  step: number
  total: number
  /** Pokaż licznik „Krok X z Y” i procent nad paskiem. */
  label?: boolean
}

/** Figma: `Progress` (licznik + procent, tor 10 px radius 6, wypełnienie violet). Szerokość liczona = jedyny dozwolony inline style. */
export function Progress({ step, total, label = true }: ProgressProps) {
  const pct = total > 0 ? Math.min(100, Math.round((step / total) * 100)) : 0
  return (
    <div className="flex flex-col gap-sm">
      {label ? (
        <div className="flex justify-between text-label">
          <span className="text-text-primary">
            Krok {step} z {total}
          </span>
          <span className="text-text-secondary">{pct}%</span>
        </div>
      ) : null}
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={step}
        aria-label={`Krok ${step} z ${total}`}
        className="h-2.5 w-full overflow-hidden rounded-[6px] bg-track"
      >
        <div
          className="h-full rounded-[6px] bg-selected transition-[width] duration-300 ease-out-soft"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
